export const devolution = {
	title: "Recargas expiradas",
	expired: "Expirado",
	toExpire: "Por expirar",
	totalExpired: "Total de recargas expiradas",
	totalToExpire: "Total de recargas por expirar",
};
